import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { Calendar, ArrowLeft } from "lucide-react";
import PageBanner from "../components/PageBanner";
import { blogPosts } from "../mock";

const BlogDetail = () => {
  const { id } = useParams();
  const post = blogPosts.find((p) => p.id === id);
  if (!post) return <Navigate to="/blog" replace />;
  const related = blogPosts.filter((p) => p.id !== id).slice(0, 2);

  return (
    <>
      <PageBanner
        title={post.title}
        crumbs={[{ label: "Insights", to: "/blog" }, { label: "Article" }]}
      />
      <section className="bg-white py-16 md:py-20">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <div className="mb-6 flex items-center gap-3 text-sm">
            <span className="font-semibold uppercase tracking-[0.14em] text-[#E4545F]">
              {post.category}
            </span>
            <span className="flex items-center gap-1.5 text-slate-400">
              <Calendar className="h-4 w-4" /> {post.date}
            </span>
          </div>
          <img
            src={post.image}
            alt={post.title}
            className="mb-10 w-full rounded-2xl object-cover shadow-md"
          />
          <div className="space-y-6">
            {post.body.map((para, i) => (
              <p key={i} className="text-lg leading-relaxed text-slate-700">
                {para}
              </p>
            ))}
          </div>

          <Link
            to="/blog"
            className="mt-12 inline-flex items-center gap-2 text-sm font-semibold text-[#0F2A4A] transition-all duration-200 hover:gap-3 hover:text-[#E4545F]"
          >
            <ArrowLeft className="h-4 w-4" /> Back to Insights
          </Link>
        </div>

        <div className="mx-auto mt-16 max-w-7xl px-4 md:px-8">
          <h3 className="mb-8 text-2xl font-semibold text-[#0F2A4A]">
            Related insights
          </h3>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {related.map((p) => (
              <Link
                key={p.id}
                to={`/blog/${p.id}`}
                className="group flex gap-5 overflow-hidden rounded-2xl border border-slate-100 p-4 transition-shadow duration-300 hover:shadow-lg"
              >
                <img
                  src={p.image}
                  alt={p.title}
                  className="h-28 w-28 flex-shrink-0 rounded-xl object-cover"
                />
                <div className="flex flex-col justify-center">
                  <span className="text-xs font-semibold uppercase tracking-[0.14em] text-[#E4545F]">
                    {p.category}
                  </span>
                  <h4 className="mt-1 text-base font-semibold leading-snug text-[#0F2A4A] group-hover:text-[#E4545F]">
                    {p.title}
                  </h4>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetail;
